"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
const graphql_tag_1 = __importDefault(require("graphql-tag"));
const meStateQuery = (0, graphql_tag_1.default)`
  query me {
    me {
      state {
        user {
          id
          active
          firstName
          lastName
          personType
          juristicPersonName
          juristicPersonLegalForm
          allowsPrivateNotifications
          hasTelegram
          account {
            id
            email {
              id
              type
              value
              isVerified
              verificationSendTime
            }
            phone {
              id
              type
              value
              isVerified
              verificationSendTime
            }
          }
        }
      }
      lockingPopup {
        fields
        hasLocking
      }
    }
  }
`;
exports.default = meStateQuery;